import { InfoCircleTwoTone } from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';

import { OfferLineItemMatch } from 'codegen';
import {
  InitialTableActions,
  TColumn,
  TEditableColumn,
  TFieldProps,
} from 'types';

export const columns = (
  lineItemOptions?: DefaultOptionType[],
  eligibleOfferOptions?: DefaultOptionType[],
): TEditableColumn<OfferLineItemMatch>[] => [{
  type: TColumn.type.Ellipsis,
  width: 250,
  title: 'Line Item',
  dataIndex: 'lineItem',
  field: {
    type: TFieldProps.type.Select,
    options: lineItemOptions,
    allowClear: false,
    rules: [{
      message: 'Item Name is required',
      required: true,
    }],
  },
}, {
  width: 300,
  title: 'Matched Offer',
  dataIndex: 'matchedOffer',
  field: {
    type: TFieldProps.type.Select,
    options: eligibleOfferOptions,
    allowClear: false,
    rules: [{
      message: 'Matched Offer is required',
      required: true,
    }],
  },
  render: (value, { matchedOffer }) => {
    const redeemedCount = matchedOffer?.redeemedCount;
    const maxRedeemedCount = matchedOffer?.maxRedeemedCount;

    if (typeof redeemedCount === 'number' && typeof maxRedeemedCount === 'number') {
      return (
        <Row gutter={6}>
          <Col xs={16}>
            <Tooltip placement='bottomLeft' title={value.label}>
              <p className='truncate mb-0'>
                {value.label}
              </p>
            </Tooltip>
          </Col>

          <Col xs={8}>
            <Tooltip
              title='This offer has usage limitation. The numbers are the amount of already redeemed awards / award limit for this offer'
              className='ml-1'
              placement='bottomLeft'
            >
              {`(${redeemedCount}/${maxRedeemedCount})`}
              {' '}
              <InfoCircleTwoTone />
            </Tooltip>
          </Col>
        </Row>
      );
    }

    return (
      <Tooltip placement='bottomLeft' title={value.label}>
        <p className='truncate mb-0'>
          {value.label}
        </p>
      </Tooltip>
    );
  },
}, {
  width: 170,
  title: 'Matched By',
  dataIndex: 'matchedBy',
  render: (matchedBy) => matchedBy && `${matchedBy.type} ${matchedBy.value}`,
}, {
  type: TColumn.type.Status,
  width: 180,
  title: 'Status',
  dataIndex: 'status',
}, {
  type: TColumn.type.Percent,
  width: 120,
  title: 'Matching Score',
  dataIndex: 'matchScore',
}, {
  type: TColumn.type.Percent,
  width: 120,
  title: 'OCR Score',
  dataIndex: 'ocrScore',
}, {
  type: TColumn.type.Status,
  width: 150,
  title: 'Issuance Status',
  dataIndex: 'issuanceStatus',
}];

export const initialTableActions = [{
  type: InitialTableActions.Delete,
}];
